<ng-container *transloco="let t; read: 'configuration'">
<div class="p-5">
  <div class="flex justify-between">
    <drdp-title [title]="pageTitle"></drdp-title>
  </div>
  <drdp-container additionClasses="mt-5">
    <div>
      <h2 class="text-[20px] font-bold mb-2">{{ t('ratingViewSetup.baseTemplate.heading') }}</h2>
      <hr>
      </div>
      <form [formGroup]="customViewForm" #ngForm="ngForm">
        <div class="form-input-label-group">
          <label class="font-normal" [ngClass]="{'required': !isView }" for="title">{{ t('common.title') }}</label>
          <mat-form-field appearance="fill">
            <input class="display" [placeholder]="t('common.title')" matInput type="text" [readonly]="isView" formControlName="title"
              required>
            @if (title.invalid) {
              <mat-error>{{ t('ratingViewSetup.baseTemplate.titleRequired') }}</mat-error>
            }
          </mat-form-field>
        </div>
        <div class="form-input-label-group">
          <label class="font-normal" [ngClass]="{'required': !isView }" for="description">{{ t('common.description') }}</label>
          <mat-form-field appearance="fill">
            <input class="display" [placeholder]="t('common.description')" matInput type="text" [readonly]="isView"
              formControlName="description" required>
            @if (description.invalid) {
              <mat-error>{{ t('ratingViewSetup.baseTemplate.descriptionRequired') }}</mat-error>
            }
          </mat-form-field>
        </div>
        @if (!isView) {
          <div class="form-input-label-group">
            <label class="font-normal" [ngClass]="{'required': !isView }" for="ageGradeInstrumentId">{{ t('common.ageGroup') }}</label>
            <mat-form-field appearance="fill" class="drdp-input">
              <mat-select formControlName="ageGradeInstrumentId" [placeholder]="t('ratingViewSetup.baseTemplate.selectBaseTemplatePlaceholder')" required
                [ngClass]="{'invalid' : ageGradeInstrumentId.invalid && ngForm.submitted }">
                <!-- Server-supplied option text: localized by the API, not by Transloco. -->
                @for (agi of ageGradeInstruments; track agi) {
                  <mat-option [value]="agi.id">
                    {{ agi.ageGradeInstrumentName }}
                  </mat-option>
                }
              </mat-select>
              @if (ageGradeInstrumentId.invalid) {
                <mat-error>{{ t('ratingViewSetup.baseTemplate.ageGroupRequired') }}</mat-error>
              }
            </mat-form-field>
          </div>
        }
        @if (isView) {
          <div class="self-start">
            <label class="font-normal" for="ageGradeInstrumentId">{{ t('common.ageGroup') }}</label>
            <mat-form-field appearance="fill">
              <input class="display" matInput [readonly]="isView" [value]="customTemplate?.ageGradeInstrument" type="text"
                formControlName="ageGradeInstrumentId" required>
            </mat-form-field>
          </div>
        }

        @if (!isView) {
          <div class="form-input-label-group mt-4">
            <label class="font-normal" [ngClass]="{'required': !isView }" for="ageGradeTemplateId">{{ t('ratingViewSetup.baseTemplate.baseTemplateColonLabel') }}
            </label>
            <mat-form-field appearance="fill" class="drdp-input">
              <mat-select formControlName="ageGradeTemplateId" [placeholder]="t('ratingViewSetup.baseTemplate.selectAgeGroupPlaceholder')" required
                [ngClass]="{'invalid' : ageGradeInstrumentId.invalid && ngForm.submitted }">
                <!-- Server-supplied option text: localized by the API, not by Transloco. -->
                @for (abt of ageGradeBaseTemplates; track abt) {
                  <mat-option [value]="abt.id">
                    {{ abt.ageGradeInstrumentCode }} - {{ abt.description }}
                  </mat-option>
                }
              </mat-select>
              @if (ageGradeTemplateId.invalid) {
                <mat-error>{{ t('ratingViewSetup.baseTemplate.baseTemplateRequired') }}</mat-error>
              }
            </mat-form-field>
            <small>{{ t('ratingViewSetup.baseTemplate.baseTemplateHint') }} </small>
          </div>
        }
        @if (isView) {
          <div class="self-start">
            <label class="font-normal" for="ageGradeTemplateId">{{ t('common.baseTemplate') }}</label>
            <mat-form-field appearance="fill">
              <input matInput class="display" [readonly]="isView" [value]="customTemplate?.ageGradeTemplate" type="text"
                formControlName="ageGradeTemplateId" required>
            </mat-form-field>
          </div>
        }


        <div class="mt-4">
          <h3 class="text-[18px] font-bold mb-2">{{ t('ratingViewSetup.baseTemplate.chooseDomains') }}</h3>
          @if (!displayMeasures) {
            <span> {{ t('ratingViewSetup.baseTemplate.chooseDomainHint') }} </span>
          }
          <div class="grid grid-cols-2 md:grid-cols-8 mt-4">
            @for (domain of templateDomains; track domain) {
              <div>
                <div class="col-span-1">
                  <!-- Server-supplied domain and measure codes below. -->
                  <h4 class="text-[16px] font-bold mb-2">{{domain.domainCode}}</h4>
                  <mat-checkbox class="font-medium" (change)="checkDomainSelected(domain)" [checked]="domain.isAllSelected"
                    [disabled]="isView" [(ngModel)]="domain.isAllSelected" [ngModelOptions]="{standalone: true}">
                    {{domain.domainCode}}
                  </mat-checkbox>
                  <div class="ml-2 hidden">
                    @for (measure of domain.measures; track measure) {
                      <div>
                        <mat-checkbox class="font-medium" (change)="checkDomainAllSelected(domain)"
                          [checked]="measure.isSelected" [disabled]="true" [(ngModel)]="measure.isSelected"
                          [ngModelOptions]="{standalone: true}">
                          {{measure.code}}
                        </mat-checkbox>
                      </div>
                    }
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

        <div class="mt-4 mb-2 flex justify-end">
          <drdp-btn (click)="submitForm()"> {{ t('common.save') }} </drdp-btn>
        </div>
      </form>
    </drdp-container>
  </div>
</ng-container>
